module.exports = __webpack_public_path__ + "static/media/17_insideyourblood.747e5a33.jpg";